export const Loading = ()=>{

    return( 
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh'}}><span  className="loader"></span></div>)
}